import React, { useContext } from "react";
import Context from "../../../Context";
import BigError from "../../Misc/BigError";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Blocker from "../../Misc/Blocker";
import StaffDetailProfile from "./StaffDetailProfile";

import { Link, Redirect } from "react-router-dom";
import EssenceFiles from "../EssenceFiles";
import EssenceStateLabel from "../EssenceStateLabel";
import EssenceAreaChange from "../EssenceAreaChange";
import EssenceActionsDropdown from "../EssenceActionsDropdown";
import FamStaff from "../../Misc/Fam/FamStaff";
import StaffDocuments from "./StaffDocuments";

export default class StaffDetail extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      customProfileKey: "",
      redirect: false,
      pending: false,
      notFound: false,
      mode: "profile",
      user: {},
      profile: {},
      method: [],
    };
  }

  componentDidMount() {
    this.load();
  }

  pending = (pending) => {
    this.setState({ pending });
  };

  load = async () => {
    this.setState({ pending: true });
    let user = {};
    let notFound = false;
    let result = await this.context.api.q("/staff/get", {
      id: this.props.staffId,
    });
    if (Object.keys(result).length) {
      user = result;

      let method = await this.context.api.qa("/staff/method", {
        id: this.props.staffId,
      });

      this.setState({ method });
    } else {
      notFound = true;
    }

    this.setState({
      pending: false,
      notFound,
      user,
      customProfileKey: this.context.key(),
    });
  };

  methodRunAsk = (methodId, methodName) => {
    this.context
      .ask(
        `Вы действительно хотите выполнить действие ${methodName} для пользователя ${this.state.user["fullname"]}`,
        "Подтверждение действия",
        "question"
      )
      .then((result) => {
        if (result.value) {
          this.methodRun(methodId, methodName);
        }
      });
  };

  methodRun = async (methodId, methodName) => {
    this.setState({ pending: true });
    let result = await this.context.api.q("/method/run", {
      id: this.props.staffId,
      method: methodId,
    });
    if (result !== false) {
      this.context.toast(`Действите "${methodName}" выполнено`, "success");
      //this.setState({ redirect: "/staff/" });
      this.load();
    } else {
      this.context.toast(
        `Не удалось выполнить действите "${methodName}"`,
        "error"
      );
      this.setState({ pending: false });
    }
  };

  renderNav() {
    let nav = {
      profile: "Профиль",
      files: "Документы",
    };
    return (
      <ul className="nav nav-tabs mb-10">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <Link
              to={`/staff/${this.props.staffId}/${id}/`}
              className={` ${
                this.props.mode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    );
  }

  renderUserButtons() {
    return (
      <div className="px-lg-15 mt-10 border-top pt-4">
        {this.state.method.map((method) => (
          <button
            key={method.action}
            onClick={() => this.methodRunAsk(method.id, method.label)}
            className="btn btn-light w-100 my-2"
          >
            {method.label}
          </button>
        ))}
      </div>
    );
  }

  render() {
    if (this.state.redirect) return <Redirect to={this.state.redirect} />;
    if (this.state.notFound) {
      return (
        <BigError
          title={"Сотрудник не найден"}
          message={`Не удалось получить информацию о сотруднике #${this.props.staffId}`}
        />
      );
    }
    return (
      <>
        <CrumbsProvider title="Карточка сотрудника" />
        <div className="row">
          <div className="col-lg-4 mb-5 mb-lg-0">
            <div className="card card-custom card-stretch">
              <div className="card-body">
                <Blocker on={this.state.pending}>
                  <UserInfo
                    profile={this.state.profile}
                    user={this.state.user}
                    onFinish={() => this.load()}
                  />
                  <div className="mt-5">
                    <FamStaff staffId={this.props.staffId} showUnfam showFam />
                  </div>
                  {this.renderUserButtons()}
                </Blocker>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="card card-custom card-stretch">
              <div className="card-body">
                <Blocker on={this.state.pending}>
                  {this.renderNav()}
                  {this.props.mode === "profile" ? (
                    <StaffDetailProfile
                      onPending={this.pending}
                      onFinish={this.load}
                      user={this.state.user}
                      key={this.state.customProfileKey}
                    />
                  ) : null}
                  {this.props.mode === "files" && this.state.user["id"] ? (
                    <StaffDocuments
                      client={this.state.user["id"]}
                      documentId={this.props.documentId}
                    />
                  ) : null}
                </Blocker>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function UserInfo(props) {
  const cx = useContext(Context);
  let user = props.user || {};
  let profile = props.profile || {};
  let literal = user["fullname"] ? user["fullname"][0].toUpperCase() : null;
  const info = user.info || {};

  const stateBgMap = {
    created: "bg-light-primary",
    enabled: "bg-light-success",
    disabled: "bg-light",
    deleted: "bg-light-danger",
  };

  return (
    <>
      <div className="d-flex align-items-center">
        <div className="symbol symbol-75 mr-5">
          {info.picture ? (
            <img alt="userpic" src={info.picture} />
          ) : (
            <span className="symbol-label bg-light-primary font-size-h4">
              {literal}
            </span>
          )}
        </div>
        <div>
          <h5>{user["fullname"]}</h5>
          <div className=" d-flex justify-content-start align-items-center">
            <EssenceActionsDropdown
              essence={"staff"}
              key={user.id}
              id={user.id}
              label={user.label}
              onFinish={props.onFinish}
            />
            <EssenceStateLabel
              id={user.id}
              stateCode={user.statecode}
              stateLabel={user.statelabel}
              essence="staff"
            />
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center my-4">
        <div>Создан</div>
        <div>
          {user["created"] ? new Date(user["created"]).toLocaleString() : "-"}
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center  my-4">
        <div>Изменен</div>
        <div>
          {user["lastupdate"]
            ? new Date(user["lastupdate"]).toLocaleString()
            : "-"}
        </div>
      </div>
      {user.userid ? (
        <div className="d-flex justify-content-between align-items-center my-4">
          <div>Логин</div>
          <div>
            {cx.user.isAdmin ? (
              <Link to={`/admin/users/${user.userid}/`}>{user.code}</Link>
            ) : (
              user.code
            )}
          </div>
        </div>
      ) : null}
    </>
  );
}
